import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { ReplaySubject } from 'rxjs';

import {
  ConfigurationService,
  SemantriaConfiguration,
} from 'app/providers/semantria-api/configuration.service';
import { GroupService } from 'app/providers/semantria-api/group.service';
import { SemantriaAccountService } from 'app/providers/semantria-api/semantria-account.service';
import { CollectionService } from 'app/providers/storage-api/collection.service';
import { ProjectService } from 'app/providers/storage-api/project.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { AuthService } from '../../../../providers/bridge-api/auth.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-configuration-list-details',
  templateUrl: './configuration-list-details.component.html',
  styleUrls: ['./configuration-list-details.component.scss'],
  standalone: false,
})
export class ConfigurationListDetailsComponent implements OnInit, OnDestroy {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  private configId: string;
  public selectedConfiguration: SemantriaConfiguration;
  accountLimits: { [key: string]: number };
  configurations: SemantriaConfiguration[];
  autoAnalysisConfigs: string[] = [];
  projectsCollections = [];
  groupId: string;
  isConfigLoading = true;

  private unsub$ = new ReplaySubject<void>(1);
  authService = inject(AuthService);

  constructor(
    private route: ActivatedRoute,
    private configurationService: ConfigurationService,
    private semantriaAccountService: SemantriaAccountService,
    private collectionService: CollectionService,
    private groupService: GroupService,
    private projectService: ProjectService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    this.collectionService
      .getAutoAnalysisConfigs()
      .then((res) => (this.autoAnalysisConfigs = res.items));

    await Promise.all([
      this.semantriaAccountService.sub
        .takeUntil(this.unsub$)
        .subscribe((res) => (this.accountLimits = res.limits)),
      this.configurationService
        .getConfigurations(true, this.groupService.getSelectedGroupId())
        .then((res) => (this.configurations = res)),
      this.projectService.searchProjects(null, null, true, true).then((res) => {
        const projects = res.items;
        for (const project of projects) {
          for (const collection of project.collections) {
            collection['projectName'] = project.name;
            this.projectsCollections.push(collection);
          }
        }
      }),
    ]);

    this.route.params.subscribe((params) => {
      this.configId = params.id;
      this.getSelectedConfig();
    });
    this.route.parent.params.subscribe((params) => {
      this.groupId = params.groupId;
    });
  }

  ngOnDestroy(): void {
    this.unsub$.next();
  }

  async getSelectedConfig() {
    this.isConfigLoading = true;

    let config = this.configurations.find((c) => c.id === this.configId);
    if (!config) {
      config = await this.configurationService.getConfiguration(this.configId);
    }

    this.selectedConfiguration = config;

    this.isConfigLoading = false;
  }

  onEditConfiguration() {
    this.router.navigate([
      `/groups/${this.groupId}/configurations/${this.selectedConfiguration.id}`,
    ]);
  }
}
